var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeliverySettingsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#FAF5F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 20.9746C19.9025 20.9746 19.805 20.9521 19.715 20.8996L13.0925 17.0671C12.83 16.9096 12.7325 16.5646 12.89 16.2946C13.0475 16.0246 13.3925 15.9346 13.6625 16.0921L20 19.7596L26.3 16.1146C26.57 15.9571 26.915 16.0546 27.0725 16.3171C27.23 16.5871 27.1325 16.9321 26.87 17.0896L20.2925 20.8996C20.195 20.9446 20.0975 20.9746 20 20.9746Z",
    fill: "#1A1A1A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 27.7703C19.6925 27.7703 19.4375 27.5153 19.4375 27.2078V20.4053C19.4375 20.0978 19.6925 19.8428 20 19.8428C20.3075 19.8428 20.5625 20.0978 20.5625 20.4053V27.2078C20.5625 27.5153 20.3075 27.7703 20 27.7703Z",
    fill: "#1A1A1A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 28.0625C19.34 28.0625 18.6875 27.92 18.17 27.635L14.165 25.4075C13.0775 24.8075 12.23 23.36 12.23 22.115V17.8775C12.23 16.6325 13.0775 15.1925 14.165 14.585L18.17 12.365C19.1975 11.795 20.8025 11.795 21.83 12.365L25.835 14.5925C26.9225 15.1925 27.77 16.64 27.77 17.885V22.1225C27.77 23.3675 26.9225 24.8075 25.835 25.415L21.83 27.635C21.3125 27.92 20.66 28.0625 20 28.0625ZM20 13.0625C19.5275 13.0625 19.0625 13.16 18.7175 13.3475L14.7125 15.575C13.9925 15.9725 13.355 17.0525 13.355 17.8775V22.115C13.355 22.94 13.9925 24.02 14.7125 24.425L18.7175 26.6525C19.4 27.035 20.6 27.035 21.2825 26.6525L25.2875 24.425C26.0075 24.02 26.645 22.9475 26.645 22.115V17.8775C26.645 17.0525 26.0075 15.9725 25.2875 15.5675L21.2825 13.34C20.9375 13.16 20.4725 13.0625 20 13.0625Z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliverySettingsIcon);
export default __webpack_public_path__ + "static/media/delivery-settings-icon.bf0b714bff30fb5ac8a7f66468e6e448.svg";
export { ForwardRef as ReactComponent };